export default __webpack_public_path__ + "static/media/loginImage.aa14986b.svg";